import React from "react";
import { createPortal } from "react-dom";
import styles from "./Modal.module.scss";

function Modal({show, children, className}) {
    if (!show) {
        return null;
    }

    return createPortal(
        <div className={styles.modalOverlay}>
            <div className={`${styles.modalContent} ${className || ""}`}>
                {children}
            </div>
        </div>,
        document.body
    );
}

export {Modal};
